import { useContext } from "react";
import utility from "src/utils/utility";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { UserType } from "src/model";
import { IndividualHome, CompanyHome, AdminHome } from "./types";

const Home: React.FC = () => {
    const {info: {userType}} = useContext(AppInfoContext)

    return (
        <>
            { userType === UserType.INDIVIDUAL ?
                <IndividualHome />
                    : userType === UserType.COMPANY ?
                        <CompanyHome />
                            : <AdminHome />
            }
        </>
    );
}

export default utility.routeData('home', 'Dashboard Home', <Home/>)